// extracted by mini-css-extract-plugin
module.exports = {"rootEmpty":"_4d8b90","noFeaturesText":"_de2bd2","mainTitle":"_01380c","title":"_401dcd","featuresRatingContainer":"_e8bdd1","featuresRating":"_67a1a3"};